import {CxEvent} from "@spartacus/core";

export class GonvarriQuickStockNotificationEvent extends CxEvent {

  static override readonly type = "GonvarriQuickStockNotificationEvent";
  productCode: string = "";
  channel?: string;

}
